import { CardSchema } from "./card";
import { z } from "zod";
export const InvoiceSchema = z.object({
    id: z.string(),
    number: z.string(),
    amount_due: z.number(),
    date: z.coerce.date(),
    hostedUrl: z.string().url(),
    card: CardSchema.nullish(),
});
export const PeriodSchema = z.object({
    start: z.coerce.date(),
    end: z.coerce.date(),
});
export const InvoiceLineSchema = z.object({
    amount: z.number(),
    period: PeriodSchema,
    proration: z.boolean(),
    description: z.string(),
    type: z.string(),
});
export const InvoiceCouponSchema = z.object({
    amount_off: z.number(),
    percent_off: z.number(),
    name: z.string(),
});
